import { Button, Input, Typography} from "@material-tailwind/react";
import axios from "axios";
import { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";

export default function RegisterPage() {
	const routerParams = useParams();
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [isPasswordStrong, setIsPasswordStrong] = useState(true);
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const inviteKey = routerParams.inviteKey;

	const onRegisterSuccess = async () => {
		toast.success("Registered successfully!");
		navigate("/login");
	};

	function isPasswordStrongEnough(password: string) {
		if (!/^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])(?=.*[^0-9a-zA-Z]).{8,}$/.test(password)) {
			return false;
		}
		if (/relay/i.test(password)) {
			return false;
		}
		return true;
	}
	

	useEffect(() => {
		axios.get(`${process.env.REACT_APP_RELAY_API_HOST}/user-register/view/${inviteKey}`)
			.then((res) => {
				if (res.data.userType !== 'SUPER_ADMIN') {
					throw new Error("Invalid invitation key");
				}
				setEmail(res.data.email);
			})
			.catch((err) => {
				toast.error("Invalid invitation key");
				navigate("/login");
			});
	  }, []);

	  useMemo(() => {
		if (!password) {
			return setIsPasswordStrong(true);
		}

		setIsPasswordStrong(isPasswordStrongEnough(password));
	}, [password]);


	const attemptRegister = async (e) => {
		e.preventDefault();

		if (password !== confirmPassword) {
			setError("Passwords do not match");
			setTimeout(() => setError(""), 2000);
			return;
		}

		if (password.length === 0) {
			setError("Please enter a password");
			setTimeout(() => setError(""), 2000);
			return;
		}

		try {
			const { data } = await axios.post(
				`${process.env.REACT_APP_RELAY_API_HOST}/user-register/register`,
				{
					password,
					inviteKey,
					phone,
					email,
					userType: 'SUPER_ADMIN',
				}
			);
			if (!data.success) {
				if (data.message) throw new Error(data.message);
				throw new Error("Registration failed");
			}
			onRegisterSuccess();
		} catch (err) {
			console.error(err);
			setError(`Registration failed: ${err}`);
			setTimeout(() => setError(""), 2000);
		}
	};

	return (
		<div className="flex flex-col justify-center px-6 lg:px-8 mt-36">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
					Register
				</h2>
			</div>

			<div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm">
				<form onSubmit={attemptRegister} className="space-y-6">
					<div>
						<div className="mt-2">
							<Input
								crossOrigin=""
								label="Email"
								value={email}
								disabled
							/>
						</div>
					</div>

					<div>
						<div className="flex items-center justify-between"></div>
						<div className="mt-2">
							<Input
								label="Phone"
								crossOrigin=""
								type="text"
								required
								onChange={(e) => setPhone(e.target.value)}
							/>
						</div>
					</div>

					<div>
						<div className="flex items-center justify-between"></div>
						<div className="mt-2">
							<Input
								label="Password"
								crossOrigin=""
								type="password"
								error={!isPasswordStrong}
								required
								onChange={(e) => setPassword(e.target.value)}
							/>
							<Typography
								variant="small"
								color="gray"
								className="flex items-center gap-1"
							>
								Use at least 8 characters, one uppercase, one lowercase, one number and one special character.
							</Typography>
						</div>
					</div>

					<div>
						<div className="flex items-center justify-between"></div>
						<div className="mt-2">
							<Input
								label="Confirm-Password"
								crossOrigin=""
								type="password"
								error={confirmPassword != '' && password !== confirmPassword}
								onChange={(e) => setConfirmPassword(e.target.value)}
								required
							/>
						</div>
					</div>

					<div>
						<Button
							type="submit"
							className="flex w-full justify-center rounded-md bg-blue-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-800"
						>
							Register
						</Button>

						{error && (
							<p className="text-center text-sm text-red-500 mt-4">{error}</p>
						)}
					</div>
				</form>
			</div>
		</div>
	);
}
